import { Component, OnInit } from '@angular/core';
import { CompletedEventCategoryModel } from 'src/app/models/completed-event/completed-event-category.model';
import { DashboardWidgetsDataService } from 'src/app/services/dashboard-widget-data.service';

interface PersonMatrixPoint extends CompletedEventCategoryModel {
  categoryKey: string;
}

@Component({
  selector: 'app-person-competency-matrix-widget',
  templateUrl: './person-competency-matrix-widget.component.html',
  styleUrl: './person-competency-matrix-widget.component.scss',
  standalone: false
})
export class PersonCompetencyMatrixWidgetComponent implements OnInit {
  personCompetencyMatrixData: PersonMatrixPoint[] = [];

  allCategoryKeys: string[] = [];
  private categoryNameByKey = new Map<string, string>();

  readonly maxCategoryLabelLength: number = 12;
  readonly maxCategoriesForPolarChart: number = 20;
  readonly maxCategoriesForInclineLabels: number = 25;

  constructor(
    private dashboardWidgetsDataService: DashboardWidgetsDataService
  ) {}

  ngOnInit() {
    this.dashboardWidgetsDataService.getPersonCompetencyMatrixData().subscribe(data => {
      if (data) {
        this.personCompetencyMatrixData = data.map((x, i) => ({
          ...x,
          categoryKey: `c${i}`
        }));

        this.allCategoryKeys = this.personCompetencyMatrixData.map(
          x => x.categoryKey
        );

        this.categoryNameByKey = new Map(
          this.personCompetencyMatrixData.map(x => [
            x.categoryKey,
            x.categoryName
          ])
        );
      }
    });
  }

  private getName(key: string): string {
    return this.categoryNameByKey.get(key) ?? key;
  }

  customizeCategoryLabel = (info: any): string => {
    const label = this.getName(info.value);

    return label.length > this.maxCategoryLabelLength
      ? label.slice(0, this.maxCategoryLabelLength) + '…'
      : label;
  };

  customizeCategoryHint = (info: any): string => {
    return this.getName(info.value);
  };

  customizeTooltip = (info: any) => ({
    text: `${this.getName(info.argument)}: ${info.value}`
  });
}
